import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { timeout, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from "../services/auth.service";
import { environment } from '../../../environments/environment';

export const qualityGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.getUserRole().pipe(
        timeout(10000),
        map((role: string | string[] | null) => {
            if (!role) {
                return router.createUrlTree(['/secure']);
            }

            const allowedRoles = [environment.salesUsersRoleName, environment.adminsRoleName];
            const hasAllowedRole = Array.isArray(role)
                ? role.some(r => allowedRoles.includes(r))
                : allowedRoles.includes(role);

            return hasAllowedRole ? true : router.createUrlTree(['/secure']);
        }),
        catchError((error: Error) => {
            console.error('Error fetching session:', error);
            return of(router.createUrlTree(['/secure']));
        })
    );
};
